(function () {
  'use strict';

  // SVG Icons for Sound Toggle
  const MUTE_ICON = `<svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>`;
  const SOUND_ICON = `<svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>`;

  function initWatchBuy(section) {
    if (!section || section.dataset.watchReady === 'true') {
      return;
    }

    section.dataset.watchReady = 'true';

    const modal = section.querySelector('[data-watch-modal]');
    if (!modal) {
      console.error('HUZAYM’S Watch & Buy: Modal not found in this section.');
      return;
    }

    // TELEPORT MODAL: Moves modal to <body> so parent transforms don't block fixed position
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const openButtons = Array.from(section.querySelectorAll('[data-watch-open]'));
    const viewerMedia = modal.querySelector('[data-watch-viewer-media]');
    const viewerImage = modal.querySelector('[data-watch-viewer-image]');
    const viewerTitle = modal.querySelector('[data-watch-viewer-title]');
    const viewerPrice = modal.querySelector('[data-watch-viewer-price]');
    const shopButton = modal.querySelector('[data-watch-shop]');
    const soundButton = modal.querySelector('[data-watch-sound]');
    const viewerContainer = modal.querySelector('.huzayms-watch-buy__viewer') || modal;

    let currentVideo = null;
    let currentIndex = 0;
    let touchStartX = 0;
    let touchStartY = 0;

    /* =====================================================
       OPEN MODAL BY INDEX (WITH SMOOTH TRANSITION)
       ===================================================== */
    function openWatch(index) {
      if (index < 0 || index >= openButtons.length) return;

      const isAlreadyOpen = modal.classList.contains('is-active');

      const loadContent = () => {
        currentIndex = index;

        const button = openButtons[currentIndex];
        const title = button.dataset.watchTitle || '';
        const price = button.dataset.watchPrice || '';
        const url = button.dataset.watchUrl || '#';
        const image = button.dataset.watchImage || '';
        const video = button.dataset.watchVideo || '';
        const poster = button.dataset.watchPoster || '';

        if (viewerTitle) viewerTitle.textContent = title;
        if (viewerPrice) viewerPrice.textContent = price;
        if (shopButton) shopButton.href = url;

        if (viewerImage) {
          viewerImage.innerHTML = '';
          if (image) {
            const img = document.createElement('img');
            img.src = image;
            img.alt = title;
            img.loading = 'eager';
            viewerImage.appendChild(img);
          }
        }

        if (viewerMedia) {
          viewerMedia.innerHTML = '';
          currentVideo = null;

          if (video) {
            const player = document.createElement('video');
            player.src = video;
            player.autoplay = true;
            player.muted = true;
            player.loop = true;
            player.playsInline = true;
            player.preload = 'auto';

            if (poster) {
              player.poster = poster;
            }

            player.setAttribute('playsinline', '');
            player.setAttribute('webkit-playsinline', '');
            viewerMedia.appendChild(player);
            currentVideo = player;

            if (soundButton) {
              soundButton.style.display = 'flex';
              soundButton.innerHTML = MUTE_ICON;
            }

            const promise = player.play();
            if (promise && promise.catch) {
              promise.catch(function () {
                console.log('HUZAYM’S Watch & Buy: autoplay was blocked.');
              });
            }
          } else if (poster) {
            const img = document.createElement('img');
            img.src = poster;
            img.alt = title;
            viewerMedia.appendChild(img);
            if (soundButton) {
              soundButton.style.display = 'none';
            }
          }
        }

        if (!isAlreadyOpen) {
          modal.classList.add('is-active');
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('huzayms-watch-buy-open');
        } else {
          // Fade back in smoothly after swapping content
          setTimeout(() => {
            viewerContainer.classList.remove('is-transitioning');
          }, 40);
        }
      };

      if (isAlreadyOpen) {
        // Trigger fade out before updating content
        viewerContainer.classList.add('is-transitioning');
        setTimeout(loadContent, 200);
      } else {
        loadContent();
      }
    }

    /* =====================================================
       CLOSE MODAL
       ===================================================== */
    function closeWatch() {
      if (currentVideo) {
        currentVideo.pause();
        currentVideo.removeAttribute('src');
        currentVideo.load();
        currentVideo = null;
      }
      if (viewerMedia) viewerMedia.innerHTML = '';
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('huzayms-watch-buy-open');
      viewerContainer.classList.remove('is-transitioning');
    }

    /* =====================================================
       EVENT DELEGATION (CARD CLICKS)
       ===================================================== */
    section.addEventListener('click', function (event) {
      const openBtn = event.target.closest('[data-watch-open]');
      if (openBtn) {
        event.preventDefault();
        const idx = openButtons.indexOf(openBtn);
        if (idx !== -1) openWatch(idx);
      }
    });

    /* =====================================================
       EVENT DELEGATION (MODAL CLICKS & SOUND TOGGLE)
       ===================================================== */
    modal.addEventListener('click', function (event) {
      const closeBtn = event.target.closest('[data-watch-close]');
      const backdrop = event.target.matches('.huzayms-watch-buy__modal-backdrop');

      if (closeBtn || backdrop) {
        event.preventDefault();
        closeWatch();
        return;
      }

      const soundBtn = event.target.closest('[data-watch-sound]');
      if (soundBtn && currentVideo) {
        event.preventDefault();
        event.stopPropagation();
        currentVideo.muted = !currentVideo.muted;
        soundBtn.innerHTML = currentVideo.muted ? MUTE_ICON : SOUND_ICON;
      }
    });

    /* =====================================================
       SWIPE GESTURE NAVIGATION
       ===================================================== */
    viewerContainer.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    viewerContainer.addEventListener('touchend', function (e) {
      if (!modal.classList.contains('is-active')) return;

      const touchEndX = e.changedTouches[0].screenX;
      const touchEndY = e.changedTouches[0].screenY;

      const diffX = touchStartX - touchEndX;
      const diffY = touchStartY - touchEndY;

      // 50px drag distance threshold
      if (Math.abs(diffX) > 50 || Math.abs(diffY) > 50) {
        if (diffX > 50 || diffY > 50) {
          // Swipe Left / Swipe Up -> Next Video
          if (currentIndex < openButtons.length - 1) {
            openWatch(currentIndex + 1);
          }
        } else if (diffX < -50 || diffY < -50) {
          // Swipe Right / Swipe Down -> Previous Video
          if (currentIndex > 0) {
            openWatch(currentIndex - 1);
          }
        }
      }
    }, { passive: true });

    /* =====================================================
       ESCAPE KEY
       ===================================================== */
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-active')) {
        closeWatch();
      }
    });
  }

  /* =======================================================
     INITIAL LOAD
     ======================================================= */
  function initialize() {
    document.querySelectorAll('.huzayms-watch-buy').forEach(function (section) {
      initWatchBuy(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  /* =======================================================
     SHOPIFY THEME EDITOR RE-INITIALIZE
     ======================================================= */
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.huzayms-watch-buy');
    if (section) {
      initWatchBuy(section);
    }
  });

})();